(function() {
	'use strict';

	angular.module('flightReports').controller('FlightReportsCtrl', FlightReportsCtrl);

	function FlightReportsCtrl(CommonMasterData, $sce, CommonLogicService, PopupManager,EventManagerService,RemoteService,PaymentRatesService,MessageService) {
		var vm = this;
		vm.tab = 1;
				
		alignHeaderStyles();
    	
    	$(window).resize(function(){
    		alignHeaderStyles();
        });
        
    	function alignHeaderStyles(){
    		var height = ($('.profile-tab-header').height() - 16)+ "px";
        	$(".profile-tab-content").css("top", height);
        	
        	height = $('.profile-tab-header>ul').height();
        	$(".profile-tab-content").css("top", height);
        	
        	height = 70 + $('.profile-tab-header').height()+ 40 + 15;
        	$(".search_panel_new").css("top", height);
    	}
    	
		vm.tabClick = function (tabID) {
            vm.tab = tabID;
        };
		
	}
}());
